module.exports = __webpack_public_path__ + "static/media/discontent.6e06c4b2.svg";